import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Form, Label } from 'semantic-ui-react';

import './InputTextField.css';


const InputTextField = props => {
  const {
    input,
    label,
    type,
    disabled,
    prefix,
    meta: { touched, error },
  } = props;

  const [isFocused, setFocused] = useState(false);

  if (!('id' in input)) {
    input.id = `id_${input.name}`;
  }

  return (
    <Form.Field
      className={`input-text-field__component ${touched && !error ? 'valid' : ''}`}
      error={Boolean(touched && error)}
    >
      <div className={`fieldset ${isFocused ? 'is-focused' : ''} ${touched && !input.value ? 'is-empty' : ''}`}>
        {prefix &&
          <span className="label-prefix">{prefix}</span>
        }
        <input
          {...input}
          disabled={disabled}
          type={type}
          data-empty={Boolean(!input.value)}
          onFocus={() => { input.onFocus(); setFocused(true); }}
          onBlur={() => { input.onBlur(); setFocused(false); }}
        />
        {label &&
          <label htmlFor={input.id}>{label}</label>
        }
      </div>

      {touched && error &&
        <Label
          color={'red'}
          pointing
        >
          {error}
        </Label>
      }
    </Form.Field>
  );
};

InputTextField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  prefix: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

InputTextField.defaultProps = {
  label: null,
  prefix: null,
  disabled: false,
};

export default InputTextField;
